import axios from 'axios';

// Normalize backend URL and always go through `/api` on the backend
const RAW_BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

let BACKEND_URL = RAW_BACKEND_URL.replace(/\/+$/, '');
if (BACKEND_URL.toLowerCase().endsWith('/api')) {
  BACKEND_URL = BACKEND_URL.slice(0, -4);
}

export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

export const axiosInstance = axios.create({
  timeout: 30000, // Increased timeout to 30s for slower backend responses
  withCredentials: true
});


